import React, { ReactNode } from 'react'
import { styled } from '@creditas/stylitas'
import { cache } from 'swr'
import { Typography } from '@creditas/typography'
import { Alert } from '@creditas/icons'
import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Card } from './Card'

const WarningWrapper = styled.div`
  display: flex;
  position: absolute;
  right: 10px;
  bottom: 10px;
`

interface State {
  hasError: boolean
}

class ErrorBoundary extends React.Component<object, State> {
  state = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  handleClick = (): void => {
    cache.delete('assignments::counter')
    cache.delete('err@assignments::counter')
    this.setState({ hasError: false })
  }

  render(): ReactNode {
    const { hasError } = this.state
    const { children } = this.props

    if (hasError) {
      return (
        <Card onClick={this.handleClick}>
          <Typography variant="support">Puxadas hoje</Typography>
          <Typography variant="support" weight="900">
            -
          </Typography>
          <WarningWrapper>
            <Alert.AlertTriangle
              color="warning"
              data-for="header-assignments-card-error-icon"
              data-tip
            />
            <ReactTooltip id="header-assignments-card-error-icon">
              {'Ocorreu um erro ao buscar a quantidade'} <br />
              {'de carteirizadas. Clique para atualizar'}
            </ReactTooltip>
          </WarningWrapper>
        </Card>
      )
    }

    return children
  }
}

export { ErrorBoundary }
